import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './App.css';
import ViewDispatcher from './Components/ViewDispatcher';
import i18n from './i18nextInit';
import { AppStyled, AppLandscape } from './Styles/Containers';
import { MySkinDiagState } from './type';
import { GlobalStyle } from './Styles/Texts';
import * as ActionTypes from './Constants/ActionsTypes';
import { getBearer } from './API/SalesForceAPI';
import { StarFeeder/*, StarFeederMakeUP */} from './Constants/Utilitaries';
import { Base64 } from 'js-base64';
import { CloseButton } from './Styles/Buttons';
import closeIcon from './Assets/Icons/Close_B.svg';
import ConfirmPopUp from './Components/ConfirmPopUp';
import { isDesktop, isTablet } from 'react-device-detect';
import TagManager from 'react-gtm-module';
import { loadFaceLandmarksDetectionModel } from './A3Camera/faceLandmarksDetection';
import { Answer } from './Constants/QuestsConstants';
import { TryOnProductClass, TryOnType } from './Constants/TryOnProduct';
// import { TryOnProductClass, TryOnType } from './Constants/TryOnProduct';
// import * as actionType from "./Constants/ActionsTypes"

declare global {
	interface Window {
		id: any;
		textAnim: any;
		disableScrolling: () => void;
		enableScrolling: () => void;
		image: HTMLImageElement;
		bridgeInterval: any;
		stepInterval: any;
		isQA: boolean;
		PRICE_QUANTITY_LANGS: string[]
		RTL_LANGS: string[];
		ASIAN_LANGS: string[];
		MAIL_DISABLED_LANGS: string[];
	}
}

const App = () => {
	const [isLandscape, setLandscape] = useState(false);
	const step = useSelector((state: MySkinDiagState) => state.session.step);
	const [closeIn, setCloseIn] = useState<boolean>(false);
	const dispatch = useDispatch();
	window.RTL_LANGS = ["he_IL", "ar_AE", "ar_SA"]
	window.PRICE_QUANTITY_LANGS = ["de_DE", "de_AT"]
	window.ASIAN_LANGS = ["en_SG", "en_MY", "en_AU", "ja_JP", "ko_KR", "zh_TW", "tw_TW", "zh_HK", "en_HK"]
	window.MAIL_DISABLED_LANGS = ["es_MX", "cs_CZ", "da_DK", "it_IT", "nl_NL", "fr_CH", "de_CH", "pt_PT", "ko_KR", "de_DE", "de_AT", "en_MEA", "en_AR", "ar_AR", "ar_SA", "ar_MEA", "en_ZA", "en_AU", "pt_BR", "en_CA", "fr_CA", "ja_JP", "en_HK", "zh_HK"]

	const tagManagerArgs = {
		gtmId: 'GTM-NDL792M',
	}

	TagManager.initialize(tagManagerArgs);

	window.addEventListener('resize', () => {
		if (!isDesktop || isTablet) {
			setLandscape(window.innerWidth > window.innerHeight);
		}
	});

	window.history.scrollRestoration = 'manual';
	const stopScrolling = (e: Event) => {
		e.preventDefault();
	};

	window.disableScrolling = () => {
		document.getElementById('APP')!.addEventListener('touchmove', stopScrolling, false);
	};

	window.enableScrolling = () => {
		document.getElementById('APP')!.removeEventListener('touchmove', stopScrolling, false);
	};

	useEffect(() => {
		loadFaceLandmarksDetectionModel().then((model) => {
			dispatch({ type: ActionTypes.UPDATE_MODEL, value: model });
		});

		if (window.innerWidth < 768) {
			setLandscape(window.innerWidth > window.innerHeight);
		}

		let url = new URL(window.location.href);
		let data: any;

		if (url.searchParams.get('bearer')) {
			StarFeeder(url.searchParams.get('bearer')!)
			// StarFeederMakeUp(url.searchParams.get('bearer')!)
		}

		if (url.searchParams.get('data')) {
			try {
				let urlString = Base64.atob(url.searchParams.get('data')!.replace(' ', '+'));
				data = JSON.parse(urlString);
				console.log(data);

				if (data['region']) {
					if (window.RTL_LANGS.includes(data['region'])) {
						document.body.style.direction = 'rtl'
					}
					switch (data['region']) {
						case 'tw_TW':
						case 'zh_TW':
							i18n.changeLanguage('tw_TW');
							break;
						case 'en_UK':
							i18n.changeLanguage('en_GB');
							break;
						default:
							i18n.changeLanguage(data['region']);
					}
				} else {
					console.warn('NO LANGUAGE PROVIDED IN DATA');
					i18n.changeLanguage('en_GB');
				}

				//check if user's coming from Desktop
				if (data['options']) {

					if (data['options']['currentUrl']) {
						let newUrl = new URL(data['options']['currentUrl']);
						let uuid = newUrl.searchParams.get('bridge');

						if (uuid) {
							dispatch({ type: ActionTypes.SET_BRIDGE, value: uuid });
							dispatch({ type: ActionTypes.SET_STEP, value: 1 });
						}
					}
				}

				if (data['mode'] !== 'try-on') {
					try {
						if (sessionStorage.getItem('questions')) {
							console.log('storage found.');
							setTimeout(() => {
								dispatch({ type: ActionTypes.SET_ANALYSE, value: JSON.parse(sessionStorage.getItem('analyses')!) });
								dispatch({ type: ActionTypes.SET_QUESTION, value: sessionStorage.getItem('questions')!.split(',') });
								dispatch({ type: ActionTypes.SET_STEP, value: 5 });
							}, 500);
						}
					} catch (error) {
						console.error('Erreur avec session Storage');
						console.error(error);
					}
				}

				// direct to results view
				if (data['goToResultView'] === true) {
					dispatch({ type: ActionTypes.SET_STEP, value: 5 });
				}

				//check if VTO
				if (data['mode'] === 'try-on') {
					dispatch({ type: ActionTypes.SET_STEP, value: 10 });
				}

				// eyJyZWdpb24iOiJmcl9GUiIsIm1vZGUiOiJ0cnktb24iLCJzdGFySUQiOiIiLCJ1c2VyRW1haWwiOiIiLCJ1c2VyU3RhdHV0IjoiIiwib3B0aW9ucyI6eyJ0cmFuc2FjdGlvbmFsIjp0cnVlLCJjdXJyZW50VXJsIjoiaHR0cHM6Ly93d3cuc2lzbGV5LXBhcmlzLmNvbS9mci1GUi9sLW9yY2hpZGVlLTEwMDEyMi5odG1sIn0sInBpZCI6InNtb2tleV9iZHIifQ==
				if (data['pid'] === "smokey_bdr") {
					let smokeyShadow = new TryOnProductClass(
						"181523-smokey-bdr-shadow", "smokey 1", 10, true, "", "", "", true, "", 38, 0, "", TryOnType.master, []
					)

					let smokeyExterieur = new TryOnProductClass(
						"181523-smokey-bdr-exterieur", "smokey 2", 10, true, "", "", "", true, "", 38, 0, "", TryOnType.master, []
					)

					let smokeyUnder = new TryOnProductClass(
						"181523-smokey-bdr-under", "smokey 3", 10, true, "", "", "", true, "", 38, 0, "", TryOnType.master, []
					)

					let smokeyPoint = new TryOnProductClass(
						"181523-smokey-bdr-interieur", "smokey 3", 10, true, "", "", "", true, "", 38, 0, "", TryOnType.master, []
					)

					let smokeyLiner = new TryOnProductClass(
						"181523-smokey-bdr-liner", "smokey Liner", 10, true, "", "", "", true, "", 38, 0, "", TryOnType.master, []
					)

					dispatch({ type: ActionTypes.UPDATE_TRYON_PRODUCTS, value: [smokeyShadow, smokeyExterieur, smokeyUnder, smokeyPoint, smokeyLiner] })
				}

				// eyJyZWdpb24iOiJmcl9GUiIsIm1vZGUiOiJ0cnktb24iLCJzdGFySUQiOiIiLCJ1c2VyRW1haWwiOiIiLCJ1c2VyU3RhdHV0IjoiIiwib3B0aW9ucyI6eyJ0cmFuc2FjdGlvbmFsIjp0cnVlLCJjdXJyZW50VXJsIjoiaHR0cHM6Ly93d3cuc2lzbGV5LXBhcmlzLmNvbS9mci1GUi9sLW9yY2hpZGVlLTEwMDEyMi5odG1sIn0sInBpZCI6InNtb2tleV90dCJ9
				if (data['pid'] === "smokey_tt") {
					let smokeyShadow = new TryOnProductClass(
						"181522-smokey-tt-shadow", "smokey 1", 10, true, "", "", "", true, "", 38, 0, "", TryOnType.master, []
					)

					let smokeyExterieur = new TryOnProductClass(
						"181522-smokey-tt-exterieur", "smokey 2", 10, true, "", "", "", true, "", 38, 0, "", TryOnType.master, []
					)

					let smokeyUnder = new TryOnProductClass(
						"181522-smokey-tt-under", "smokey 3", 10, true, "", "", "", true, "", 38, 0, "", TryOnType.master, []
					)

					let smokeyPoint = new TryOnProductClass(
						"181522-smokey-tt-interieur", "smokey 4", 10, true, "", "", "", true, "", 38, 0, "", TryOnType.master, []
					)

					let smokeyLiner = new TryOnProductClass(
						"181522-smokey-tt-liner", "smokey Liner", 10, true, "", "", "", true, "", 38, 0, "", TryOnType.master, []
					)

					dispatch({ type: ActionTypes.UPDATE_TRYON_PRODUCTS, value: [smokeyShadow, smokeyExterieur, smokeyUnder, smokeyLiner, smokeyPoint] })
				}

				// eyJyZWdpb24iOiJmcl9GUiIsIm1vZGUiOiJ0cnktb24iLCJzdGFySUQiOiIiLCJ1c2VyRW1haWwiOiIiLCJ1c2VyU3RhdHV0IjoiIiwib3B0aW9ucyI6eyJ0cmFuc2FjdGlvbmFsIjp0cnVlLCJjdXJyZW50VXJsIjoiaHR0cHM6Ly93d3cuc2lzbGV5LXBhcmlzLmNvbS9mci1GUi9sLW9yY2hpZGVlLTEwMDEyMi5odG1sIn0sInBpZCI6ImhhbG9fYmRyIn0=
				if (data['pid'] === "halo_bdr") {
					let haloShadow = new TryOnProductClass(
						"181523-halo-bdr-shadow", "halo 1", 10, true, "", "", "", true, "", 38, 0, "", TryOnType.master, []
					) 

					let haloUnder = new TryOnProductClass(
						"181523-halo-bdr-under", "smokey 3", 10, true, "", "", "", true, "", 38, 0, "", TryOnType.master, []
					)

					let haloLightPoint = new TryOnProductClass(
						"181523-halo-bdr-light-point", "halo 4", 10, true, "", "", "", true, "", 38, 0, "", TryOnType.master, []
					)

					let haloPaillette = new TryOnProductClass(
						"181523-halo-bdr-paillette", "halo paillette", 10, true, "", "", "", true, "", 38, 0, "", TryOnType.master, []
					)

					dispatch({ type: ActionTypes.UPDATE_TRYON_PRODUCTS, value: [haloShadow, haloUnder, haloPaillette, haloLightPoint] })
				}

				// eyJyZWdpb24iOiJmcl9GUiIsIm1vZGUiOiJ0cnktb24iLCJzdGFySUQiOiIiLCJ1c2VyRW1haWwiOiIiLCJ1c2VyU3RhdHV0IjoiIiwib3B0aW9ucyI6eyJ0cmFuc2FjdGlvbmFsIjp0cnVlLCJjdXJyZW50VXJsIjoiaHR0cHM6Ly93d3cuc2lzbGV5LXBhcmlzLmNvbS9mci1GUi9sLW9yY2hpZGVlLTEwMDEyMi5odG1sIn0sInBpZCI6ImhhbG9fdHQifQ==
				if (data['pid'] === "halo_tt") {
					let haloShadow = new TryOnProductClass(
						"halo-tt-shadow", "halo 1", 10, true, "", "", "", true, "", 38, 0, "", TryOnType.master, []
					)

					// let halo2 = new TryOnProductClass(
					// 	"181522-halo-2", "halo 2", 10, true, "", "", "", true, "", 38, 0, "", TryOnType.master, []
					// )

					let haloTTunder = new TryOnProductClass(
						"halo-tt-under", "smokey 3", 10, true, "", "", "", true, "", 38, 0, "", TryOnType.master, []
					)

					let halo4 = new TryOnProductClass(
						"halo-tt-light-point", "halo 4", 10, true, "", "", "", true, "", 38, 0, "", TryOnType.master, []
					)

					let haloPaillette = new TryOnProductClass(
						"halo-tt-paillette", "halo paillette", 10, true, "", "", "", true, "", 38, 0, "", TryOnType.master, []
					)

					dispatch({ type: ActionTypes.UPDATE_TRYON_PRODUCTS, value: [haloShadow, haloTTunder, haloPaillette, halo4] })
				}

			} catch (e) {
				console.error(e);
				console.warn('DATA UNREADABLE');
				i18n.changeLanguage('en_GB');
			}
		} else {
			i18n.changeLanguage('en_GB');
			// document.body.style.direction = 'rtl'
		}

		if (url.searchParams.get("debug") === "true") {
			dispatch({
				type: ActionTypes.SET_ANALYSE, value: [
					{ name: "WRINKLES", score: 0.3952355714285714 },
					{ name: "WRINKLES_UNDER_EYE", score: 0.5552355714285714 },
					{ name: "DARK_SPOTS", score: 0.544971, image: "https://s3.eu-west-1.amazonaws.com/otstc.photos/ab…22796695&Signature=nHQrsAAJz896qB63TB2s7AT5WJQ%3D" },
					{ name: "SHININESS", score: 0.865034, image: "https://s3.eu-west-1.amazonaws.com/otstc.photos/ab…796695&Signature=Xf6kxvvX1aTRyM0H%2B929CZVQpTQ%3D" },
					{ name: "RADIANCE", score: 0.443158, image: "https://s3.eu-west-1.amazonaws.com/otstc.photos/ab…796695&Signature=Jt%2FeKLoL9EUaDUaREOIAJzfiw98%3D" },
					{ name: "BLACK_SPOTS", score: 0.5, image: "https://s3.eu-west-1.amazonaws.com/otstc.photos/ab…&Signature=%2FeGZm%2FTORc%2FNzp4M%2Fbf0cgQ3SwA%3D" },
					{ name: "ACNE", score: 0.75, image: "https://s3.eu-west-1.amazonaws.com/otstc.photos/ab…22796695&Signature=49TYD4Xp8k94WsJslO4aQQsehLg%3D" },
					{ name: "HOLLOW_CHEEKS", score: 0.6 },
					{ name: "HYDRATION", score: 0 },
					{ name: "LOSS_OF_FIRMNESS", score: 0.4 },
					{ name: "DARK_CIRCLES", score: 0.9 },
					{ name: "EYES_BAGS", score: 0.2 },
					{ name: "ROUGHNESS", score: 0.9 },
				]
			})
			dispatch({ type: ActionTypes.SET_QUESTION, value: ["femme", [Answer.PPtracesResiduelles, Answer.PPimperfections], [Answer.CYpoche], Answer.seche, Answer.specifiqueVisage, Answer.avecRincage, Answer.MVoui, Answer.SDNoui, Answer.stress] })
			dispatch({ type: ActionTypes.SET_STEP, value: 5 })
		}

		let siteURL = new URL(window.location.href)

		window.isQA = true

		if (siteURL.searchParams.get("data")) {
			let data = JSON.parse(atob(siteURL.searchParams.get("data")!.replace(" ", "+")))
			if (data["options"]) {
				let parentURL = data["options"]["currentUrl"]
				if (parentURL) {
					if (parentURL.includes("stg-sis") || parentURL.includes("dev-sis")) {
						window.isQA = true
					} else if (parentURL.includes("sisley-paris")) {
						window.isQA = false
					}
				}
			}
		}

		//eslint-disable-next-line
	}, []);

	useEffect(() => {
		let url = new URL(window.location.href);

		const bridgeId = url.searchParams.get('bridge');
		if (bridgeId) {
			dispatch({ type: ActionTypes.SET_BRIDGE, value: bridgeId });
			dispatch({ type: ActionTypes.SET_STEP, value: 1 });
		}

	}, [dispatch])

	useEffect(() => {
		setTimeout(() => {
			getBearer(dispatch, i18n.language);
		}, 500);
		//eslint-disable-next-line
	}, [i18n, dispatch]);

	const displayClosePopUp = () => {
		if (closeIn) {
			return (
				<div style={{ width: '100vw', height: '100vh', top: 0, position: 'fixed', zIndex: 10 }}>
					<ConfirmPopUp key={0} setOptIn={setCloseIn} />
				</div>
			);
		} else {
			return <div />;
		}
	};

	return (
		<div>
			{!isLandscape || step === 0 || step === 8 || step === 10 ? (
				<AppStyled id={'APP'} step={step}>
					<GlobalStyle />
					{step === 3 && <CloseButton style={{ zIndex: 15 }} src={closeIcon} alt='close' onClick={() => setCloseIn(true)}></CloseButton>}
					{displayClosePopUp()}
					<ViewDispatcher />
				</AppStyled>
			) : (
				<AppLandscape />
			)}
		</div>
	);
};

export default App;
